import { render, staticRenderFns } from "./PropertyAddFormWrapper.vue?vue&type=template&id=cabe6c94&scoped=true&"
import script from "./PropertyAddFormWrapper.vue?vue&type=script&lang=js&"
export * from "./PropertyAddFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAddFormWrapper.vue?vue&type=style&index=0&id=cabe6c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabe6c94",
  null
  
)

export default component.exports